import React from 'react'
import { Button, Paper } from '@material-ui/core'
import { strings } from '../../../localization/strings'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography/Typography'

const styles = {
    table: {
        display: 'flex',
        flexDirection: 'column',
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '8px 8px',
        borderBottom: '1px solid #f7b500',
    },
    row_underline: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '8px 8px',
        borderBottom: '3px solid #f7b500',
    },
    cell: {
        flexGrow: 2,
        width: 250,
    },
    cellSm: {
        flexGrow: 2,
        width: 80,
    },
}

class Component extends React.Component {
    state = {}

    render() {
        let { summaryItems, handlePrint } = this.props

        if (!summaryItems) {
            return null
        }

        if (!summaryItems.length) {
            return (
                <Paper
                    style={{
                        padding: 10,
                        margin: 10,
                        background: '#f7b500',
                        opacity: 0.5,
                        textAlign: 'center',
                    }}
                >
                    {strings.movements_notFoundData}
                </Paper>
            )
        }

        return (
            <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Typography variant={'body1'} style={styles.row_underline}>
                    {strings.movements_foundData}
                </Typography>

                <div style={styles.table}>
                    {summaryItems.map((item, index) => {
                        return (
                            <div style={styles.row} key={index}>
                                <div style={styles.cell}>
                                    <TextField
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                            style: {
                                                paddingTop: '2px',
                                                paddingRight: '10px',
                                            },
                                        }}
                                        margin="none"
                                        fullWidth
                                        label={
                                            strings.movements_serviceNameLabel
                                        }
                                        defaultValue={item.ServiceName}
                                    />
                                </div>
                                <div style={styles.cellSm}>
                                    <TextField
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                            style: { paddingTop: '5px' },
                                        }}
                                        margin="none"
                                        size="small"
                                        fullWidth
                                        label={strings.movements_sourceLabel}
                                        defaultValue={
                                            item.SourceServiceAreaName
                                        }
                                    />
                                </div>
                                <div style={styles.cellSm}>
                                    <TextField
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                            style: { paddingTop: '5px' },
                                        }}
                                        margin="none"
                                        size="small"
                                        fullWidth
                                        label={
                                            strings.movements_destinationLabel
                                        }
                                        defaultValue={
                                            item.DestinationServiceAreaName
                                        }
                                    />
                                </div>
                                <div style={styles.cellSm}>
                                    <TextField
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                            style: { paddingTop: '5px' },
                                        }}
                                        margin="none"
                                        size="small"
                                        fullWidth
                                        label={strings.movements_countLabel}
                                        defaultValue={item.Count}
                                    />
                                </div>
                                <div style={styles.cellSm}>
                                    <TextField
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                            style: { paddingTop: '5px' },
                                        }}
                                        margin="none"
                                        size="small"
                                        fullWidth
                                        label={
                                            strings.movements_noVatAmountLabel
                                        }
                                        defaultValue={
                                            '$ ' + item.NoVatAmount.toFixed(2)
                                        }
                                    />
                                </div>
                                <div style={styles.cellSm}>
                                    <TextField
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                            style: { paddingTop: '5px' },
                                        }}
                                        margin="none"
                                        size="small"
                                        fullWidth
                                        label={
                                            strings.movements_totalNoVatAmountLabel
                                        }
                                        defaultValue={
                                            '$ ' +
                                            item.TotalNoVatAmount.toFixed(2)
                                        }
                                    />
                                </div>
                                <div style={styles.cellSm}>
                                    <TextField
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                            style: { paddingTop: '5px' },
                                        }}
                                        margin="none"
                                        size="small"
                                        fullWidth
                                        label={
                                            strings.movements_totalAmountLabel
                                        }
                                        defaultValue={
                                            '$ ' + item.TotalAmount.toFixed(2)
                                        }
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-around',
                        marginTop: 20,
                        marginBottom: 20,
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handlePrint}
                        fullWidth
                        size="small"
                        style={{ marginTop: 10, width: 250 }}
                    >
                        {strings.movements_download}
                    </Button>
                </div>
            </div>
        )
    }
}

export default Component
